import React, {memo, Suspense} from "react"
import {MANIFEST} from "@manifest/header"
import {useTemplatedComponent} from "@next/templating"
import connect from "./connect"

export type CheckoutProps = {
    enable: boolean
    text: string
    url: string
    dataGaV1?: string
    dataGaV2?: string
    dataGaV3?: string
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
    xxlBreakpointEnabled: boolean
}

export const Checkout = memo<CheckoutProps>(({templating, ...props}) => {
    const TemplatedCheckout = useTemplatedComponent(templating, MANIFEST)
    return (
        <Suspense>
            <TemplatedCheckout {...props} />
        </Suspense>
    )
})
Checkout.displayName = "Checkout"

export default connect(Checkout)
